import { render, staticRenderFns } from "./SearchResultVerticals.vue?vue&type=template&id=48151038&"
import script from "./SearchResultVerticals.vue?vue&type=script&lang=js&"
export * from "./SearchResultVerticals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports